import React from 'react'
import { boolean } from 'yup'
import Loader from '../../../../components/Loader'
import cx from '../../../../utils/cx'
import { ButtonContainer } from './styled'

const NFTButton = (
  props: React.PropsWithChildren<{
    solid?: boolean
    disabled?: boolean
    loading?: boolean
    className?: string
    title?: string
    style?: React.CSSProperties
    onClick?: () => void
    htmlType?: 'submit' | 'reset' | 'button'
  }>
) => {
  const onClick = () => {
    if (!props.disabled && !props.loading && props.onClick) {
      props.onClick()
    }
  }

  return (
    <ButtonContainer
      title={props.title}
      className={
        cx({ disabled: props.disabled, loading: props.loading, solid: props.solid }) + ' ' + (props.className ?? '')
      }
      onClick={onClick}
      style={props.style}
      type={props.htmlType ? props.htmlType : 'button'}
    >
      {props.loading && <Loader />}
      {props.children}
    </ButtonContainer>
  )
}
export default NFTButton
